module.exports = __webpack_public_path__ + "img/img6.6c35b62f.png";